import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from "@angular/router";
import { SharedService } from "./../../../shared/shared.service";

@Component({
  selector: 'admin-home',
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.css']
})
export class AdminHomeComponent implements OnInit {

  constructor(private sharedService: SharedService,
    private router: Router) { }

  ngOnInit() {
    let adminToken = this.sharedService.getAdminTokenAtLocStorage();
    if (adminToken == null) {
      this.router.navigate(["/login"]);
    }
  }

  showLeftMenu:boolean=true;

  logout(): void {
    this.sharedService.removeAdminTokenAtLocStorage();
    this.router.navigate(["/login"]);
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/components/admin-home/admin-home.component.ts